import { Translation, useTranslation } from "../core/translation.core";
import ExclamationTriangleIcon from "./exclamationTriangle.icon";

export default function ErrorCenterIcon({ reason }: { reason: any }) {
  const trans = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-10 text-red-400">
      <ExclamationTriangleIcon className="w-20 h-20" />

      {getErrorMessage(reason, trans)}
    </div>
  );
}

function getErrorMessage(reason: any, { t, msg }: Translation) {
  if (!reason) return null;
  if (reason.message) return reason.message;

  if (reason === "dataNotFound") return t(msg.general.dataNotFound);

  return typeof reason === "string" ? reason : JSON.stringify(reason);
}
